import { requests } from '../apiAgent';

export const OperationsCenterRepository = {
    getAllTypes: () => {
        return requests
            .get('/jerusalem/api/v2.0.0/operation-centers')
            .then((response) => response);
    },

    delete: (body: { WorkshiftSchedulingOperationCentersIds: number[] }) => {
        return requests
            .deleteWithBody(
                '/jerusalem/api/v2.0.0/workshift-scheduling-operation-centers/',
                body
            )
            .then((response) => response);
    },

    create: (body: {
        EmployeesIds: (string | number)[];
        StartDate: string;
        EndDate: string;
        OperationCenterId: number;
    }) => {
        return requests
            .post(
                '/jerusalem/api/v2.0.0/workshift-scheduling-operation-centers',
                body
            )
            .then((response) => response);
    },
};
